import { Button, Form, Input } from 'antd';
import useDuplicateLoginStep from './useDuplicateLoginStep.hook';
import { StyledDuplicateLoginStep } from './DuplicateLoginStep.styled';
import { Paragraph, Text } from '@/shared/Typography';

export default function DuplicateLoginStep({ flowState, flowActions }) {
  const { state, actions } = useDuplicateLoginStep({ flowState, flowActions });

  return (
    <StyledDuplicateLoginStep>
      <div className="content">
        <Paragraph className="bigger-text">
          Log in as{' '}
          <Text strong className="username">
            {flowState.studentData.selectedDuplicate},
          </Text>
        </Paragraph>

        <Paragraph className="bigger-text">
          Type your password to continue:
        </Paragraph>
        <Form
          initialValues={{ remember: false }}
          layout="vertical"
          onFinish={actions.duplicateLogin}
          autoComplete="off"
        >
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              placeholder="Password"
              autoComplete="one-time-code"
            />
          </Form.Item>

          <Form.Item className="login-btn">
            <Button
              htmlType="submit"
              type="primary"
              size="large"
              block
              disabled={state.loading}
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
        <div className="wrong-user">
          <Button
            style={{ marginTop: 0 }}
            block
            size="large"
            className="mt back-btn"
            disabled={state.loading}
            onClick={actions.goBack}
          >
            Go back
          </Button>
        </div>
      </div>
    </StyledDuplicateLoginStep>
  );
}
